// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"section_wrapper__dDUsA","title":"section_title__YeEVj"};